import script from "./AccountTypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountTypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./AccountTypeSelector.vue?vue&type=style&index=0&id=2cd8e5e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd8e5e8"]])

export default __exports__